var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product)?_c('li',{staticClass:"search-item dropdown-item p-2"},[_c('router-link',{staticClass:"product-link d-flex align-items-center text-left",attrs:{"to":{
      name: 'ProductDetail',
      params: { id: _vm.product.id },
      query: { feature: _vm.feature, exp: _vm.experimentCorrelationId },
    }}},[_c('img',{staticClass:"product-img mr-2",attrs:{"src":_vm.productImageUrl,"alt":""}}),_c('span',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.product.name))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }